// Placeholder trainer profiles — replace with confirmed names, photos,
// specialties and qualifications once supplied by Firm Fit Factory.
const trainers = [
  {
    id: "trainer-1",
    name: "Trainer Name (placeholder)",
    specialty: "Strength & Conditioning",
    qualification: "Certification placeholder",
    experience: "Experience placeholder",
    bio: "Bio placeholder — add a short trainer introduction once confirmed by the client.",
    social: { instagram: "#", facebook: "#" },
  },
  {
    id: "trainer-2",
    name: "Trainer Name (placeholder)",
    specialty: "Functional Training",
    qualification: "Certification placeholder",
    experience: "Experience placeholder",
    bio: "Bio placeholder — add a short trainer introduction once confirmed by the client.",
    social: { instagram: "#", facebook: "#" },
  },
  {
    id: "trainer-3",
    name: "Trainer Name (placeholder)",
    specialty: "Weight Management",
    qualification: "Certification placeholder",
    experience: "Experience placeholder",
    bio: "Bio placeholder — add a short trainer introduction once confirmed by the client.",
    social: { instagram: "#", facebook: "#" },
  },
  {
    id: "trainer-4",
    name: "Trainer Name (placeholder)",
    specialty: "Personal Training",
    qualification: "Certification placeholder",
    experience: "Experience placeholder",
    bio: "Bio placeholder — add a short trainer introduction once confirmed by the client.",
    social: { instagram: "#", facebook: "#" },
  },
];

export default trainers;
